import { useDebouncedEffect } from '@react-hookz/web';
import { useState } from 'react';

export const DEFAULT_DEBOUNCE_DELAY_IN_MS = 300;

export const useDebouncedValue = <T>(value: T, delay = DEFAULT_DEBOUNCE_DELAY_IN_MS): T => {
  const [delayedState, setDelayedState] = useState(value);
  useDebouncedEffect(() => setDelayedState(value), [value], delay);

  return delayedState;
};
